import { defineMessages } from 'react-intl';

export default defineMessages({
  fundsInTheSM: 'Funds in the Safety Module',
  totalEmissionPerDay: 'Total emission per day',
});
